import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output, signal } from '@angular/core';
import { AccountColorBackgroundDirective } from '@shared/directives/account-color-background.directive';
import { NgClass } from '@angular/common';
import { TsButtonModule, TSIconModule } from 'tsui';
import { AccountColor } from '@core/models';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'ts-panel',
  standalone: true,
  imports: [AccountColorBackgroundDirective, TSIconModule, TsButtonModule, NgClass, MatProgressSpinnerModule],
  templateUrl: './ts-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TsPanelComponent {
  @Input() headerColor: AccountColor['name'];
  @Input() title: string;
  @Input() displayPanelOptions = true;
  @Input() disablePanelOptions = false;
  @Input() loading = false;

  @Output() panelOptionsClicked = new EventEmitter();
}
